//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RegisterForm from '../../../../shared-components/generico/RegisterForm';
import { copyObject } from '../../../../common/functions/helpers';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'TipoAcaoSideColumn',
  data() {
    return {
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      disableButton: false,
      originalTipoAcao: {
        nome: '',
        idExterno: null,
        indAtivo: true,
      },
      tipoAcao: {
        nome: '',
        idExterno: null,
        indAtivo: true,
        tipo: 'MARGEM',
      },
      tipos: [
        { tipo: 'FIXO', descricao: this.$t('label.gasto_fixo') },
        { tipo: 'MARGEM', descricao: this.$t('label.margem') },
      ],
    };
  },
  components: {
    RegisterForm,
  },
  computed: {
    ...generateComputed('Tipo Acao', [
      'canAccessCRUD',
    ]),
  },
  methods: {
    cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm() {
      this.tipoAcao = copyObject(this.originalTipoAcao);
      setTimeout(() => {
        this.errors.clear();
        this.source = [];
      }, 1E2);
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      if (cb) {
        cb();
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    openSaveDialog(ref, from) {
      this.$validator.validateAll()
        .then((isValid) => {
          if (!isValid) {
            return;
          }
          const content = this.$t('message.salvar_novo_tipo_acao');
          this.setDialogContent(content, this.save, from || this.dialog.from);
          this.openDialog(ref || this.dialog.ref);
        });
    },
    save(item) {
      const tipoAcao = Object.assign({}, item || this.tipoAcao);
      this.$emit('SIDECOLUMN_SAVE_ACTION', tipoAcao, this.clearForm);
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
  },
  mounted() {
    this.originalTipoAcao = copyObject(this.tipoAcao);
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-acao/TipoAcaoLateral.vue?vue&type=script&lang=js&